import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_REPORT
} from "./actionType";

import {
  getReportSuccess,
  getReportFail
} from "./action";

//Include Both Helper File with needed methods
import {
  getReportApi
} from "../../helpers/backend_helper";

function* getReport({ payload: {report, path}}) {
  try {
    const response = yield call(getReportApi, report, path);
    yield put(getReportSuccess(GET_REPORT, response.data));
  } catch (error) {
    yield put(getReportFail(GET_REPORT, error));
  }
}


export function* watchGetReport() {
  yield takeEvery(GET_REPORT, getReport);
}

function* reportSaga() {
  yield all([
    fork(watchGetReport)
  ]);
}

export default reportSaga;
